import { forwardRef, useEffect, useId, useRef } from 'react';
import { Loader } from 'modules/Loader';
import { useForkedRef } from 'modules/utils';
import { MenuInput } from './MenuInput';
import { SearchContainer, SearchContainerInput, SearchContainerIcon } from './styled';
export const MenuHeaderInput = forwardRef((props, ref) => {
    const { id, icon, value, placeholder, loading, disabled, actions, autoFocus = true, type = 'text', onChange } = props;
    const generatedId = useId();
    const inputId = id || generatedId;
    const inputDisabled = loading || disabled;
    const innerRef = useRef(null);
    const forkedRef = useForkedRef(ref, innerRef);
    /**
     * Focused by hand rather than with React's `autoFocus` attribute. The popup is
     * portaled to the end of `<body>` and floating-ui positions it asynchronously,
     * so at the moment `autoFocus` fires the input is still at the document
     * origin — and focusing it there scrolls the window to the top of the page.
     * `preventScroll` keeps the focus and drops the scroll.
     */
    useEffect(() => {
        var _a;
        if (autoFocus) {
            (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
        }
    }, [autoFocus]);
    const handleChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.currentTarget.value);
    };
    return (<SearchContainer $sticky data-id="menu-header-sticky">
      {icon && <SearchContainerIcon>{icon}</SearchContainerIcon>}
      <MenuInput render={<SearchContainerInput ref={forkedRef} id={inputId} value={value} placeholder={placeholder} disabled={inputDisabled} type={type} onChange={handleChange}/>}/>
      {loading && (<SearchContainerIcon>
          <Loader size="xs"/>
        </SearchContainerIcon>)}
      {!loading && <SearchContainerIcon>{actions}</SearchContainerIcon>}
    </SearchContainer>);
});
